import {
    LOGIN_LOGS_REQUEST,
    LOGIN_LOGS_FAILURE,
    LOGIN_LOGS_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const loginLogListReducer = (state = initialState, action) => {
    const { type, data } = action;
    switch (type) {
        case LOGIN_LOGS_SUCCESS: return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        };
        case LOGIN_LOGS_REQUEST: return {
            ...state,
            isFetching: true,
        };
        case LOGIN_LOGS_FAILURE: return { ...state, isFetching: false };
        default: return state;
    }
};
